import { Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

const StepBoxContainer = styled.div`
  background-color: var(--primary-dark);
  border-radius: 0.5rem;
  padding: 2rem;

  display: flex;
  gap: 1rem;
  min-height: 100%;
`;

export const StepBox = (props) => {
  return (
    <StepBoxContainer>
      <Typography
        variant='h3'
        className='secondary--text sirukota-text'
      >
        {props.step ? props.step + '.' : '#'}
      </Typography>
      <Typography
        variant='body1'
        className='white--text'
      >
        {props.children}
      </Typography>
    </StepBoxContainer>
  )
}
